module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "oldClass": "{'text-align-right': field.align == 'right'}"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.field.title))]), _vm._v(" "), (_vm.uploading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.record[_vm.field.name]), function(file, fileIndex) {
    return _c('div', {
      key: fileIndex
    }, [_c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.fileNameFromStoragePath(file.url)) + "\n            ")]), _vm._v(" \n            "), _c('v-icon', {
      attrs: {
        "small": "",
        "color": "grey lighten-1",
        "xxstyle": "float:right"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFileFromGroup(file)
        }
      }
    }, [_vm._v("cancel")])], 1)
  })], 2), _vm._v(" "), _c('div', [_c('UploadWrapper', {
    on: {
      "click": _vm.doNothing,
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    attrs: {
      "color": _vm.field.color,
      "disabled": _vm.field.disabled
    }
  }, [_vm._v(_vm._s(_vm.field.title))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e9601a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/FileField.vue
// module id = 2535
// module chunks = 1